
define(
	'Tavanoteam.TavanoTeam_Sticky_Back_To_Top_Extension.StickyBackToTop'
	, [
		'jQuery'
	]
	, function (
		jQuery
	) {
		'use strict';

		return {
			
			mountToApp: function mountToApp(container) {

				var layout = container.getComponent('Layout');

				// Enable Sticky Back To Top
				layout.addToViewContextDefinition('GlobalViews.BackToTop.View', 'tavanoTeamStickyBackToTop', 'boolean', function (context) {
					
					return true;
				});

				// Scroll Settings
				var togglePoint = jQuery(window).height() + 200;
				var toggleStatus = false;
				var scrollHandling = true;
				var elementScrollDelay = 200; // (milliseconds) adjust to the highest acceptable value

				var scrollToggleClass = function () {

					toggleStatus = !toggleStatus;
					jQuery('#tt-sticky-back-to-top-container').toggleClass('tt-sticky-back-to-top-show');
				}

				var scrollHeaderBehavior = function () {

					// check positions for events
					if (jQuery(window).scrollTop() > togglePoint) {
						
						if (!toggleStatus) {

							scrollToggleClass();
						}
					} else {

						if (toggleStatus) {

							scrollToggleClass();
						}
					}
				};

				// Scroll
				jQuery(window).scroll(function () {
					
					if (scrollHandling) {

						// Scroll execution frequency
						scrollHandling = false;
						
						var allowScrollFunction = function () {
							
							scrollHeaderBehavior();
							scrollHandling = true;
							clearInterval(allowScrollInterval);
						};

						var allowScrollInterval = setInterval(allowScrollFunction, elementScrollDelay);
					}
				});

				// Resize
				jQuery(window).resize(function () {

					scrollHeaderBehavior();
				});
			}
		};
	}
);
